var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkedinFillCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 0C7.5215 0 0 7.5215 0 16.8C0 26.0785 7.5215 33.6 16.8 33.6C26.0785 33.6 33.6 26.0785 33.6 16.8C33.6 7.5215 26.0785 0 16.8 0ZM12.6875 23.7633H9.2855V12.8153H12.6875V23.7633ZM10.9655 11.4712C9.891 11.4712 9.19625 10.71 9.19625 9.7685C9.19625 8.80775 9.912 8.06925 11.0092 8.06925C12.1065 8.06925 12.7785 8.80775 12.7995 9.7685C12.7995 10.71 12.1065 11.4712 10.9655 11.4712ZM25.1125 23.7633H21.7105V17.696C21.7105 16.2838 21.217 15.3247 19.9868 15.3247C19.047 15.3247 18.4888 15.974 18.242 16.5988C18.151 16.821 18.1283 17.136 18.1283 17.4493V23.7615H14.7245V16.3065C14.7245 14.9398 14.6807 13.797 14.6353 12.8135H17.591L17.7468 14.3342H17.815C18.263 13.6202 19.3603 12.5667 21.196 12.5667C23.4343 12.5667 25.1125 14.0665 25.1125 17.29V23.7633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedinFillCircle);
export default __webpack_public_path__ + "static/media/ic-linkedin-fill-circle.51dbbbf513c496cdf7db7cca2d556f4c.svg";
export { ForwardRef as ReactComponent };